<template>
  <!-- ▼Main Container -->
  <div class="boss-main-wrap boss-main-content-wrap">
    <table
      v-if="reservations.length"
      class="unstriped hover boss-table"
    >
      <thead>
        <tr>
          <th class="boss-table-head-center pega-reservation-name-width">
            予約名
          </th>
          <th class="boss-table-head-center pega-reservation-subject-width">
            件名
          </th>
          <th class="boss-table-head-center">
            スカウト特典
          </th>
          <th class="boss-table-head-center">
            送信開始予定
          </th>
          <th class="boss-table-head-center pega-reservation-status-width">
            送信状況
          </th>
          <th class="boss-table-head-center pega-reservation-target-width">
            対象(送信完了/送信対象)
          </th>
          <template v-if="isSendScout">
            <th class="boss-table-head-center boss-operation">
              編集
            </th>
            <th class="boss-table-head-center boss-operation">
              削除
            </th>
          </template>
        </tr>
      </thead>
      <tbody>
        <scout-reservation-outline
          v-for="reservation in reservations"
          :key="reservation.id"
          :contract-id="Number($route.params.contractId)"
          :job-id="Number($route.params.jobId)"
          :reservation="reservation"
          :show-edit="isSendScout"
          @fetch="fetchReservations"
        />
      </tbody>
    </table>
    <div
      v-else
      data-test="no-reservation"
      class="grid-x grid-margin-y align-center margin-top-2"
    >
      <span class="cell medium-4 subheader text-center">スカウト送信予約がありません。</span>
    </div>
  </div>
  <!-- ▲Main Container -->
</template>

<script>
import ScoutReservationOutline from '@/components/molecules/ScoutReservationOutline'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    ScoutReservationOutline
  },
  data () {
    return {
      reservations: []
    }
  },
  computed: {
    ...mapGetters([
      'isSendScout'
    ])
  },
  watch: {
    $route: {
      handler () {
        this.fetchReservations()
      }
    }
  },
  created () {
    this.fetchReservations()
    this.storeMaster('specialFavors')
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ]),
    fetchReservations () {
      return this.$http.secured.get(`/scout/view/scouts/contracts/${this.$route.params.contractId}/jobs/${this.$route.params.jobId}/scouts/reservations`)
        .then(response => this.$set(this, 'reservations', response.data))
    }
  }
}
</script>
